import {Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, Inject} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
declare let ga: any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'app',
  template: require('./app.component.html')
})
export class AppComponent implements OnInit {

  isBrowser: boolean;

  constructor(private router: Router, @Inject('isBrowser') isBrowser){
    this.isBrowser = isBrowser;
  }

  ngOnInit(): void {
    if(this.isBrowser){
      this.router.events.subscribe(event => {
        if(event instanceof NavigationEnd){
          window.scrollTo(0,0);
          ga('set', 'page', event.urlAfterRedirects);
          ga('send', 'pageview');
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/app.component.ts